export enum AccessType {
    NO_ACCESS ="NO_ACCESS",
     DEMO_ACCESS="DEMO_ACCESS", 
     FULL_ACCESS="FULL_ACCESS"
  }
  